var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-group header" },
    [
      _c(_vm.field.subtype, { tag: "component" }, [
        _vm._v("\n    " + _vm._s(_vm.field.label) + "\n  ")
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }